import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { selectShopEventProductDetails } from '@selectors/shopEvent';

const useTimeoutToggle = () => {
  const [isVisible, setIsVisible] = useState(true);
  const setHidden = () => setIsVisible(false);
  const { productId } = useSelector(selectShopEventProductDetails);

  useEffect(() => {
    if (!isVisible) {
      setIsVisible(true);
    }
  }, [productId]);

  useEffect(() => {
    let timeoutId;

    if (!isVisible) {
      timeoutId = setTimeout(() => {
        setIsVisible(true);
      }, 30 * 1000);
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [isVisible]);

  return [isVisible, setHidden];
};

export default useTimeoutToggle;
